


import React, { useState, useContext } from 'react';
import CheckIn from './CheckIn'; // Ensure the path is correct
import CheckOut from './CheckOut'; // Ensure the path is correct
import AdultsDropdown from './AdultsDropdown'; // Ensure the path is correct
import KidsDropdown from './KidsDropdown'; // Ensure the path is correct
import { RoomContext } from '../context/RoomContext'; // Import RoomContext correctly
import { SpinnerDotted } from 'spinners-react'; // Import spinner component
import { formatLocalDate } from '../utils/dateUtils';

const BookForm = () => {
  const { adults, kids, fetchAvailableRooms: fetchAvailableRoomsForStay } = useContext(RoomContext); // Access RoomContext values
  const [checkIn, setCheckIn] = useState(new Date()); // Check-in date state
  const [checkOut, setCheckOut] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow; // Default check-out date to one day after check-in
  });
  const [loading, setLoading] = useState(false); // Loading state for API requests

  const parseGuestCount = (value) => parseInt(String(value).split(' ')[0], 10) || 0;

  const handleCheckInChange = (date) => {
    setCheckIn(date);
    if (date >= checkOut) {
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      setCheckOut(nextDay);
    }
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const minCheckOutDate = new Date(checkIn);
  minCheckOutDate.setDate(minCheckOutDate.getDate() + 1);

  // Fetch available rooms for the selected date range
  const fetchAvailableRooms = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading animation
    const adultsCount = parseGuestCount(adults);
    const kidsCount = parseGuestCount(kids);
    const checkInDate = formatLocalDate(checkIn);
    const checkOutDate = formatLocalDate(checkOut);
    const numberOfDays = Math.ceil((checkOut - checkIn) / (1000 * 3600 * 24));

    if (numberOfDays < 1) {
      alert('Check-out date must be later than check-in date.');
      setLoading(false);
      return;
    }

    try {
      const { rooms: availableRooms } = await fetchAvailableRoomsForStay({
        checkInDate,
        checkOutDate,
        adultsCount,
        kidsCount,
        showLoader: false,
      });

      if (availableRooms.length === 0) {
        alert('No rooms available for these dates and guest count. Try different dates.');
      }
    } catch (error) {
      console.error('Error fetching available rooms:', error);
      alert(error.message || 'Could not check availability. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full p-4 bg-white shadow-lg rounded-lg">
      {/* Loading Spinner */}
      {loading && (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10">
          <SpinnerDotted size={70} color="white" />
        </div>
      )}

      <form onSubmit={fetchAvailableRooms} className="relative">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-3">
          {/* Check-In Date Picker */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <CheckIn selectedDate={checkIn} onChangeDate={handleCheckInChange} minDate={today} />
          </div>

          {/* Check-Out Date Picker */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <CheckOut selectedDate={checkOut} onChangeDate={setCheckOut} minDate={minCheckOutDate} />
          </div>

          {/* Adults Dropdown */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <AdultsDropdown />
          </div>

          {/* Kids Dropdown */}
          <div className="flex-1 flex items-center border border-gray-300 rounded-lg p-3 bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
            <KidsDropdown />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full lg:w-auto ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-yellow-500 to-yellow-600'
            } text-white font-bold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-transform duration-300 transform hover:scale-105`}
            disabled={loading} // Disable button during loading
          >
            {loading ? 'Loading...' : 'Check Now'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookForm;


